export default __webpack_public_path__ + "static/media/49ers.0f3f0478.png";